import gql from 'graphql-tag';

const QUERY_ESIM_LICENSES = gql`
  query esimLicenses {
    esimLicenses {
      isSuccess
      message
      licenses {
        id
        isAllowedDual
        licenseType
        name
        productId
        storage
      }
    }
  }
`;

export default QUERY_ESIM_LICENSES;
